import { useEffect, useRef, useState } from 'react';
import RFB from '@novnc/novnc/lib/rfb';
import Swal from 'sweetalert2';

export default function VncViewer({ url, password, onDisconnect, onReboot, vmName }) {
  const containerRef = useRef(null);
  const rfbRef = useRef(null);
  const [status, setStatus] = useState('Connecting...');
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!containerRef.current || !url) return;

    const rfb = new RFB(containerRef.current, url);
    rfbRef.current = rfb;

    rfb.scaleViewport = true;
    rfb.resizeSession = false;

    rfb.addEventListener('connect', () => {
      setStatus('Connected');
      setConnected(true);
    });

    rfb.addEventListener('disconnect', (e) => {
      const reason = e.detail.reason != null ? `: ${e.detail.reason}` : '';
      setStatus(e.detail.clean ? 'Disconnected' : `Connection failed${reason}`);
      setConnected(false);
    });

    rfb.addEventListener('credentialsrequired', () => {
      console.log(password);
      rfb.sendCredentials({ password: password ?? '' });
    });

    rfb.addEventListener('securityfailure', (e) => {
      setStatus(`Auth failed${e.detail.reason ? ': ' + e.detail.reason : ''}`);
      setConnected(false);
    });

    return () => {
      rfb.disconnect();
    };
  }, [url, password]);

  const sendCtrlAltDel = () => rfbRef.current?.sendCtrlAltDel();
  const disconnect = () => {
    rfbRef.current?.disconnect();
    onDisconnect?.();
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', background: '#1a1a1a' }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: '12px',
        padding: '8px 16px', background: '#2d2d2d', borderBottom: '1px solid #444',
        flexShrink: 0,
      }}>
        <span style={{ fontWeight: 600, color: '#fff', fontSize: 14 }}>{vmName ? `${vmName}` : 'Console'}</span>
        <span style={{
          fontSize: 12, padding: '2px 10px', borderRadius: 12,
          background: connected ? '#166534' : '#7f1d1d',
          color: connected ? '#bbf7d0' : '#fecaca',
          maxWidth: 400, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }} title={status}>
          {status}
        </span>
        <div style={{ flex: 1 }} />
        <button onClick={sendCtrlAltDel} disabled={!connected} style={btnStyle(connected)}>
          Ctrl+Alt+Del
        </button>
        {onReboot && (
          <button onClick={async () => {
            const { isConfirmed } = await Swal.fire({
              title: 'Reboot VM?', text: 'Reboot this virtual machine?', icon: 'warning',
              showCancelButton: true, confirmButtonColor: '#92400e', cancelButtonColor: '#374151',
              confirmButtonText: 'Reboot', background: '#1f2937', color: '#f9fafb',
            });
            if (!isConfirmed) return;
            try {
              await onReboot();
              Swal.fire({ title: 'Reboot initiated', icon: 'success', timer: 1500, showConfirmButton: false, background: '#1f2937', color: '#f9fafb' });
            } catch (err) {
              Swal.fire({ title: 'Error', text: err.response?.data?.message ?? err.message, icon: 'error', background: '#1f2937', color: '#f9fafb' });
            }
          }} style={btnStyle(true, '#451a03', '#fb923c')}>
            Reboot
          </button>
        )}
        <button onClick={disconnect} disabled={!connected} style={btnStyle(connected, '#7f1d1d', '#fecaca')}>
          Disconnect
        </button>
      </div>
      <div ref={containerRef} style={{ flex: 1, overflow: 'hidden', background: '#000' }} />
    </div>
  );
}

function btnStyle(enabled, bg = '#1e3a5f', color = '#93c5fd') {
  return {
    padding: '4px 12px', borderRadius: 6, border: 'none',
    cursor: enabled ? 'pointer' : 'not-allowed',
    background: enabled ? bg : '#333',
    color: enabled ? color : '#666',
    fontSize: 12, fontWeight: 500,
  };
}
